import { IconInfoRegular, Text } from '@croquiscom-pvt/zds';
import styled from '@emotion/styled';

import { numberWithCommas } from '@common/utils';

interface Props {
  price: number;
}

export const FirstOrder: React.FC<Props> = ({ price }) => {
  return (
    <FirstOrderWrapper>
      <IconInfoRegular width={18} height={18} color='textSecondary' style={{ minWidth: 18, marginRight: 3 }} />
      <Text variant='Body_13_Regular' color='textSecondary' style={{ wordBreak: 'keep-all' }}>
        첫구매가는 ID당 최초 1개 상품에만 적용되며 해당 상품 포함 {numberWithCommas(price)}원 이상 주문 시 구매 가능
        (배송비 제외)
      </Text>
    </FirstOrderWrapper>
  );
};

const FirstOrderWrapper = styled.div`
  display: flex;
  align-items: flex-start;
`;
